import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/agendamento-exame`

    return {
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        getJornadas(queryParms) {
            return repository.get(`${baseUrl}/jornada?${urlUtil.serialize(queryParms)}`)
        },
        getKits(queryParms) {
            return repository.get(`${baseUrl}/kit?${urlUtil.serialize(queryParms)}`)
        },
        getExameAmbulatorioAtendimento(queryParms) {
            return repository.get(`${baseUrl}/exame-ambulatorio-atendimento?${urlUtil.serialize(queryParms)}`)
        },
        descartarExameAmbulatorioAtendimento(params) {
            return repository.post(`${baseUrl}/descartar-exame-ambulatorio-atendimento`, params)
        },
        getSupervisor(queryParms) {
            return repository.get(`${baseUrl}/supervisor?${urlUtil.serialize(queryParms)}`)
        },
        getCotas(queryParms) {
            return repository.get(`${baseUrl}/cota?${urlUtil.serialize(queryParms)}`)
        },
        saveExameBloqueado(params) {
            return repository.post(`${baseUrl}/save-exame-bloqueado`, params)
        },
        getAgendamento(id) {
            return repository.get(`${baseUrl}/agendamento/${id}`)
        },
        getDetalhamento(id) {
            return repository.get(`${baseUrl}/detalhamento/${id}`)
        },
        printEtiqueta(id) {
            return repository.get(`${baseUrl}/etiqueta/${id}`)
        },
        printProtocolo(id) {
            return repository.get(`${baseUrl}/protocolo/${id}`)
        },
        getHistoricoMedicamento(id) {
            return repository.get(`${baseUrl}/historico-medicamento/${id}`)
        },
        getHistoricoExame(id) {
            return repository.get(`${baseUrl}/historico-exame/${id}`)
        },
    }
}